// Modules
import Vuex from 'vuex';
import Vue from 'vue';
// Helpers
import defaultStateConfig from './default.state.config';
import defaultStateGlobal from './default.state.global';
import configMutations from './helpers/config/mutations';
import globalMutations from './helpers/global/mutations';
// Getters
import cartIsWaitingForDecision from './getters/global/cartIsWaitingForDecision';
import configAvatar from './getters/config/avatar';
import unreadedNewsCount from './getters/global/unreadedNewsCount';
// Actions

// Add Vuex to the app
Vue.use(Vuex);

const moduleConfig = {
  namespaced: true,
  state: JSON.parse(JSON.stringify(defaultStateConfig)),
  mutations: configMutations,
  getters: {
    getAvatar: configAvatar
  }
};

const globalElements = {
  namespaced: true,
  state: JSON.parse(JSON.stringify(defaultStateGlobal)),
  mutations: globalMutations,
  getters: {
    cartIsWaitingForDecision,
    unreadedNewsCount
  }
};

export default new Vuex.Store({
  modules: {
    config: moduleConfig,
    global: globalElements
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js